<script lang="ts">
  export let backgroundColor: string
  export let size: number
  export let borderColor: string | undefined = undefined

  let styleList = [
    `background-color: ${backgroundColor} !important`,
    `width: ${size}px`,
    `height: ${size}px`,
  ]

  if (borderColor) {
    styleList.push(`border-color: 1px solid ${borderColor} !important`)
  }
  
  const style = styleList.join(";")
</script>

<div style={style} class={$$props.class}>
  <slot></slot>
</div>

<style>
  div {
    border-radius: 50%;
    display: inline-block;
  }
</style>
